import { render, staticRenderFns } from "./MemberIntegral.vue?vue&type=template&id=89597848&scoped=true&"
import script from "./MemberIntegral.vue?vue&type=script&lang=js&"
export * from "./MemberIntegral.vue?vue&type=script&lang=js&"
import style0 from "./MemberIntegral.vue?vue&type=style&index=0&id=89597848&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89597848",
  null
  
)

export default component.exports